import { render } from "./qcp-app.vue?vue&type=template&id=a829c2b2"
import script from "./qcp-app.vue?vue&type=script&lang=js"
export * from "./qcp-app.vue?vue&type=script&lang=js"
script.render = render

export default script